import { mapGetters, mapActions } from 'vuex';
import Modal from '@/components/Modal.vue';
import Daterangepicker from '@/components/Daterangepicker.vue';
// import Overview from '@/components/Overview.vue';
import ProductsSelect from '@/components/ProductsSelect.vue';
import Overviews from '@/components/inventories/Overviews.vue';
import { StockUpdate } from '@/lib/statics';
import {
	duplicateVar,
	getDateRange,
	getProductStock,
	downloadFile,
} from '@/lib/helper';
import productsApi from '@/api/products';

const defaultFilterDate = getDateRange();
const defaultProduct = { _id: { $oid: 0 }, name: 'All Products' };
const defaultVariation = { _id: 0, name: '', label: 'All Variations' };

export default {
	name: 'Inventory',
	components: {
		Modal,
		Daterangepicker,
		// Overview,
		Overviews,
		ProductsSelect,
	},
	data() {
		return {
			filterKeyword: '',
			limit: 25,
			page: 1,
			sort_by: '_id',
			sort: 'desc',
			products: [],
			activities: [],
			selectedActivity: null,
			selectedProduct: null,
			selectedVariation: null,
			isFetching: false,
			isAll: false,
			isShowDeleteOrderBulk: false,
			isShowDetails: false,
			filterDate: defaultFilterDate,
			isShowFilter: false,
			isRouteChecked: false,
			isShowAdvancedFilters: false,
			isShowUpdateStock: false,
			isUpdatingStock: false,
			stockUpdateType: StockUpdate.TYPE_SYNC,
			stockQty: 0,
			stockDescription: '',
			stockVariation: null,
			isExporting: false,
		};
	},
	methods: {
		...mapActions({
			fetchUser: 'fetchUser',
			fetchMembers: 'members/fetch',
		}),
		parsePricing(price) {
			if (typeof price !== 'string') {
				price = price.toString();
			}

			let parsedPrice = price.replace(/[^0-9]/g, '').trim();
			const parsedPriceLength = parsedPrice.length;
			if (parsedPriceLength > 1 && parsedPrice.charAt(0) === '0') {
				parsedPrice = parsedPrice.substring(1, parsedPriceLength);
			}
			return parsedPrice;
		},
		stockInputValidation() {
			if (this.stockQty < 0) {
				this.stockQty = 0;
			} else {
				this.stockQty = this.parsePricing(this.stockQty);
			}
		},
		toggleStats() {
			this.showStats = !this.showStats;
		},
		resetActivities() {
			this.activities = [];
			this.isAll = false;
			this.page = 1;
		},
		fetchActivities(reset = true) {
			const productId = this.selectedProduct ? this.selectedProduct._id.$oid : null;
			if (!productId) {
				return;
			}
			this.isFetching = true;
			if (reset) {
				this.resetActivities();
			}
			const params = this.getFetchParams();
			const callback = (response) => {
				const activities = response.data;
				if (this.activities.length === 0) {
					this.activities = activities;
				} else {
					this.activities = this.activities.concat(activities);
				}
				this.page++;
				if (activities.length === 0) {
					this.isAll = true;
				}
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.isFetching = false;
			};
			productsApi.getActivities(productId, params, callback, errorCallback);
		},
		fetchProducts() {
			const params = {
				limit: 200,
				sort_by: 'created_at',
				sort: 'asc',
				page: 1,
			};

			if (this.supplierId && this.isAdmin) {
				params.user_id = this.supplierId;
			}

			const callback = (response) => {
				this.products = response.data.products ? response.data.products : response.data;
			};
			const errorCallback = () => {};
			productsApi.getProducts(params, callback, errorCallback);
		},
		fetchData(reset = true) {
			this.fetchActivities(reset);
		},
		fetchAll() {
			if (this.products.length === 0) {
				this.fetchProducts();
			}

			const params = {
				limit: 1000,
				sort_by: 'name',
				sort: 'asc',
				page: 1,
				include_owner: true,
			};

			if (this.supplierId && this.isAdmin) {
				params.user_id = this.supplierId;
			}

			this.fetchMembers(params);

			// if (this.productId && this.selectedProduct && this.selectedProduct.type === 'simple') {
			// 	this.fetchData();
			// }
		},
		init() {
			// this.checkCapabilities();
			this.initFilterDate();
			this.fetchAll();
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const since = this.moment(filterDate.start).format('YYYY-MM-DD');
			const until = this.moment(filterDate.end).format('YYYY-MM-DD');
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetchData();
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				self.fetchActivities();
			}, 1000);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchActivities(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchActivities(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		showDetails(activity, event) {
			event.preventDefault();
			this.selectedActivity = activity;
			this.isShowDetails = true;
		},
		hideDetails() {
			this.isShowDetails = false;
			this.selectedActivity = null;
		},
		applyFilter() {
			const query = duplicateVar(this.$route.query);
			const params = { query };
			this.$router.push(params);
			this.isShowFilter = false;
		},
		checkCapabilities() {
			if (!this.isUserCan('inventory_view')) {
				this.$router.push('/');
			} else {
				this.isRouteChecked = true;
			}
		},
		formatDate(dateString) {
			const format = 'DD-MM-YYYY - HH:mm';
			const timezone = this.user.timezone;
			const formattedDate = this.moment.utc(dateString).tz(timezone).format(format);
			return dateString && dateString !== '' ? formattedDate : '';
		},
		initFilterDate() {
			if (this.since && this.since !== '' && this.until && this.until !== '') {
				const since = this.moment(this.since);
				const until = this.moment(this.until);
				const filterDate = {
					start: since,
					end: until,
				};
				this.filterDate = filterDate;
			}
		},
		getStock(product) {
			const stock = getProductStock(product);
			return stock;
		},
		getMemberName(id) {
			let memberName = '';
			const member = this.members.find(member => member._id === id);

			if (member) {
				if ((member.role === 'admin' || member.role === 'superadmin') && !this.isAdmin) {
					memberName = 'Admin';
				} else {
					memberName = member.name;
				}
			} else {
				memberName = '';
			}

			return memberName;
		},

		getFetchParams() {
			const variationName = this.variationName;
			const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				since: startDate,
				until: endDate,
			};

			if (this.supplierId) {
				params.user_id = this.supplierId;
			}

			if (variationName && variationName !== '') {
				params.variation = variationName;
			}

			if (this.filterKeyword && this.filterKeyword !== '') {
				params.keyword = this.filterKeyword;
			}

			return params;
		},

		onVariationSelect() {
			this.fetchData();
		},

		updateProductStock(productId, stock) {
			const productIndex = this.products.findIndex(product => product._id.$oid === productId);
			if (productIndex !== -1) {
				this.products[productIndex].stock.quantity = stock.quantity;
			}
		},

		/**
		* Show adjust stock popup
		*
		* @param {'sync' | 'increase' | 'decrease'} type Update Type
		* @param {number} quantity Stock Quantity
		* @param {string} [variation] the variation name whose stock you want to change.
		*/
		showAdjustStock(type = StockUpdate.TYPE_SYNC, product, variation) {
			if (type === StockUpdate.TYPE_SYNC) {
				const isVariable = product.type === 'variable';
				const quantity = isVariable && variation && variation.stock ? variation.stock.quantity : product.stock.quantity;
				this.stockQty = quantity;
			} else {
				this.stockQty = 0;
			}
			this.stockUpdateType = type;
			this.isShowUpdateStock = true;
			if (variation) {
				this.stockVariation = variation.name;
			}
		},

		/**
		 * Update Product Stock
		 *
		 * @param {string} productId Product ID
		 * @param {'increase' | 'decrease' | 'sync'} type Type of stock update
		 * @param {number} quantity Stock quantity
		 * @param {string} description Stock change description
		 * @param {string} [variation] Variation name
		*/
		updateStock(productId, type, quantity, description, variation) {
			this.isUpdatingStock = true;
			const params = { type, quantity, description };
			if (variation) {
				params.variation = variation;
			}
			const callback = (response) => {
				if (variation) {
					const variationsPrices = response.data.variations.prices;
					this.updateVariationPricesStock(productId, variationsPrices);
				} else {
					const stock = response.data.stock;
					if (stock) {
						this.updateProductStock(productId, stock);
					}
				}

				if (response.data.activity) {
					const activity = response.data.activity;
					this.activities.unshift(activity);
				}

				this.isUpdatingStock = false;

				this.$notify({
					group: 'inventory',
					text: 'Stock successfully updated.',
					type: 'success',
				});

				this.resetStockUpdate();

				// Hide popup
				this.isShowUpdateStock = false;
			};
			const errorCallback = () => {
				this.isUpdatingStock = false;
				this.$notify({
					group: 'inventory',
					text: 'Stock update occurred an error, please try again.',
					type: 'danger',
				});
			};
			productsApi.updateStock(productId, params, callback, errorCallback);
		},

		/**
		* Reset stock update value
		*/
		resetStockUpdate() {
			this.stockQty = 0;
			this.stockDescription = '';
			this.stockVariation = null;
		},

		/**
		 * Update Variation Prices Stock
		 * @param {VariationPrice[]} prices Variations Prices
		 */
		updateVariationPricesStock(productId, prices) {
			const productIndex = this.products.findIndex(product => product._id.$oid === productId);
			if (productIndex !== -1) {
				for (let index = 0; index < this.products[productIndex].variations.prices.length; index++) {
					const variationPrice = this.products[productIndex].variations.prices[index];
					const sameNameIndex = prices.findIndex(price => price.name === variationPrice.name);
					if (sameNameIndex !== -1) {
						const price = prices[sameNameIndex];
						this.products[productIndex].variations.prices[index].stock.quantity = price.stock.quantity;
					}
				}
			}
		},

		/**
		 * Export Inventory
		 */
		exportInventory() {
			const productId = this.selectedProduct ? this.selectedProduct._id.$oid : null;
			this.isExporting = true;
			const dateFormat = 'YYYY-MM-DD';
			const startDate = this.moment(this.filterDate.start).format(dateFormat);
			const endDate = this.moment(this.filterDate.end).format(dateFormat);
			const params = {
				sort_by: this.sort_by,
				sort: this.sort,
				since: startDate,
				until: endDate,
			};

			if (this.supplierId && this.isAdmin) {
				params.user_id = this.supplierId;
			}

			const callback = (response) => {
				this.isExporting = false;
				// const file = response.data;
				// const files = file.split('/');
				// const fileDir = `${files[0]}/${files[1]}`;
				// const fileName = files[2];
				// const fileNameEncoded = encodeURIComponent(fileName);
				// const path = `${fileDir}/${fileNameEncoded}`;
				// const prefix = 'https://api.ostock.id';
				// const url = `${prefix}/${path}`;
				const url = response.data;
				downloadFile(url);
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			productsApi.export(productId, params, callback, errorCallback);
		},
		getWarehouseLabel(act) {
			return act?.data?.warehouse?.warehouse_label ?? '-';
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isUserCan: 'isUserCan',
			isAdmin: 'isAdmin',
			presetRangeLabel: 'presetRangeLabel',
			filterDatePresets: 'filterDatePresets',
			members: 'members/all',
			isDropshipper: 'isDropshipper',
		}),
		productsList() {
			const allProduct = duplicateVar(defaultProduct);
			let list = [allProduct];
			list = list.concat(this.products);
			return list;
		},
		productsFiltered() {
			return this.products.filter(product => product.stock && product.stock.enabled);
		},
		variationsList() {
			const defaultOption = duplicateVar(defaultVariation);
			let list = [defaultOption];
			const prices = this.selectedProduct && this.selectedProduct.variations && this.selectedProduct.variations.prices ? this.selectedProduct.variations.prices : [];
			const pricesLabeled = prices.map((price) => {
				price.label = price.name.split('||').join(' - ');
				return price;
			});
			list = list.concat(pricesLabeled);
			return list;
		},
		productId() {
			return this.$route.query.product_id;
		},
		supplierId() {
			return this.$route.query.supplier_id ?? null;
		},
		variationName() {
			return this.selectedVariation ? this.selectedVariation.name : null;
		},
		since() {
			const since = this.$route.query.since;
			return since;
		},
		until() {
			const until = this.$route.query.until;
			return until;
		},
		isVariableProduct() {
			return this.selectedProduct && this.selectedProduct.type === 'variable';
		},
	},
	watch: {
		user() {
			this.init();
		},
		productId() {
			// if (this.selectedProduct.type === 'simple') {
			// 	this.selectedVariation = null;
			// 	this.fetchData();
			// } else {
			// 	this.selectedVariation = duplicateVar(defaultVariation);
			// }
		},
		products(products) {
			if (this.productId) {
				let product = products.find(product => product._id.$oid === this.productId);
				if (!product) {
					product = defaultProduct;
				}
				this.selectedProduct = product;
			} else if (products.length > 0) {
				this.selectedProduct = products[0];
			}
		},
		selectedProduct(product) {
			const productId = product._id.$oid;
			const query = duplicateVar(this.$route.query);
			const params = {};
			if (productId === 0) {
				delete query.product_id;
			} else {
				query.product_id = productId;
			}

			if (product.type === 'simple') {
				this.selectedVariation = null;
				this.fetchData();
			} else {
				this.selectedVariation = duplicateVar(defaultVariation);
			}

			params.query = query;
			this.$router.push(params);
		},
		selectedVariation() {
			if (this.selectedVariation) {
				this.fetchData();
			}
		},
	},
	created() {
		if (this.user) {
			this.init();
		}
		window.addEventListener('scroll', this.handleScroll);
		document.addEventListener('scroll', this.onDocumentScroll, true);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
		document.removeEventListener('scroll', this.onDocumentScroll, true);
	},
};
